import { HttpRequest } from "./utils/HttpRequest";

export default class Global {
  httpReq = new HttpRequest();
  //Services
  getGlobalOptions(token: string, lang?: string): Promise<any> {
    let data: any = { token };
    if (lang) data = { ...data, APP_LANG: lang };
    return this.httpReq.post(`ws-security/globalOptions`, {
      ...data,
    });
  }

  updatePendingRequest(token: string, id: string, action: string) {
    return this.httpReq.post(`ws-security/updatePendingRequest`, {
      token,
      id,
      action,
    });
  }
}
